var r=r=>r,a=r,e=r;export{a as scan,e as withScan};